function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef } from "react";
import { Row, Container, Col } from 'react-bootstrap';
import { Modal, Input, Button } from 'antd';
import PatientView from "../PatientView";
import PatientQrCodeViewBracelet from "../PatientQrCodeViewBracelet";
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Search = Input.Search;
var SearchPatientQrCode = function SearchPatientQrCode() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isPatientModalOpen = _useState2[0],
    setIsPatientModalOpen = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    searchId = _useState4[0],
    setSearchId = _useState4[1];
  var ref = useRef();
  var onSearch = function onSearch(v) {
    if (v.length > 0) {
      setSearchId(v);
      setIsPatientModalOpen(true);
    }
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(Row, {
      children: /*#__PURE__*/_jsx(Col, {
        lg: 12,
        md: 12,
        children: /*#__PURE__*/_jsx(Search, {
          placeholder: "Entrez ID ou Telephone",
          size: "large",
          onSearch: onSearch,
          enterButton: true,
          style: {
            width: '100%',
            marginBottom: '20px'
          }
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "BRACELET PATIENT"
      }),
      destroyOnClose: true,
      open: isPatientModalOpen,
      onCancel: function onCancel() {
        setIsPatientModalOpen(false);
      },
      width: {
        xs: '95%',
        sm: '90%',
        md: '80%',
        lg: '80%',
        xl: '50%',
        xxl: '50%'
      },
      footer: [/*#__PURE__*/_jsx(ReactToPrint, {
        content: function content() {
          return ref.current;
        },
        children: /*#__PURE__*/_jsx(PrintContextConsumer, {
          children: function children(_ref) {
            var handlePrint = _ref.handlePrint;
            return /*#__PURE__*/_jsx(Button, {
              type: "primary",
              onClick: handlePrint,
              children: /*#__PURE__*/_jsx("b", {
                children: "IMPRIMER"
              })
            });
          }
        })
      }), /*#__PURE__*/_jsx(Button, {
        type: "default",
        onClick: function onClick() {
          setIsPatientModalOpen(false);
        },
        children: "Quitter"
      })],
      children: /*#__PURE__*/_jsx("div", {
        style: {
          background: "#F3F2EE",
          padding: "21px"
        },
        children: /*#__PURE__*/_jsx("div", {
          ref: ref,
          children: /*#__PURE__*/_jsx(PatientQrCodeViewBracelet, {
            id: "prtdiv",
            pid: searchId
          })
        })
      })
    })]
  });
};
export default SearchPatientQrCode;